import { getGitbaseMode } from '$lib/services/integrations/gitbase/mode';
import {
  mergeGitbasePrefsSecrets,
  stripGitbasePrefsSecrets,
} from '$lib/services/integrations/gitbase/session-secrets';

const GITBASE_USER_KEY = 'gitbase-cms.user';

/** @returns {Promise<Record<string, unknown> | undefined>} */
export const getGitbaseUserCache = async () => {
  try {
    const raw = sessionStorage.getItem(GITBASE_USER_KEY);

    if (!raw) {
      return undefined;
    }

    const parsed = JSON.parse(raw);

    return typeof parsed === 'object' && parsed !== null ? parsed : undefined;
  } catch {
    return undefined;
  }
};

/** @param {Record<string, unknown>} userCache */
export const setGitbaseUserCache = async (userCache) => {
  sessionStorage.setItem(GITBASE_USER_KEY, JSON.stringify(userCache));
};

export const clearGitbaseUserCache = async () => {
  sessionStorage.removeItem(GITBASE_USER_KEY);
};

/** @returns {'google' | 'local'} */
export const getGitbaseAuthModeFromSignIn = (backendName, token) => {
  if (backendName === 'local') {
    return 'local';
  }

  return token ? 'google' : 'google';
};

export { mergeGitbasePrefsSecrets, stripGitbasePrefsSecrets, getGitbaseMode };
